import { InternalElement } from "../lib/internal-element.js";
import { formatCurrency } from "../lib/utils.js";
import { css, html } from "lit";
import { customElement } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let LandingPageAction = class extends InternalElement {
  render() {
    var _a, _b, _c, _d, _e;
    return html`
      <a class="action-button" href=${((_a = this.quote) == null ? void 0 : _a.checkout_url) ?? ""} target="_blank">
        <strong>Purchase ${(_b = this.quote) == null ? void 0 : _b.product.friendly_name} for ${((_c = this.quote) == null ? void 0 : _c.total) ? formatCurrency((_d = this.quote) == null ? void 0 : _d.total, (_e = this.quote) == null ? void 0 : _e.currency) : ""}</strong>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
      </a>
    `;
  }
};
LandingPageAction.styles = css`
    :host {
      margin: auto;
    }

    a.action-button {
      border: none;
      padding: 12px 12px;
      font-size: var(--default-vi-font-md);
      background-color: var(--default-vi-secondary-color);
      color: var(--default-vi-secondary-contrast-color);
      font-family: var(--default-vi-font-family);
      text-decoration: none;
      border-radius: var(--default-vi-action-border-radius);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    a.action-button svg {
      margin-left: 5px;
    }

    a.action-button:hover {
      opacity: 0.9;
    }
  `;
LandingPageAction = __decorateClass([
  customElement("landing-page-action")
], LandingPageAction);
export {
  LandingPageAction
};
